<template>
  <el-row class="ordercard_framework">
    <el-descriptions class="order_description" title="" :column="1">
      <el-descriptions-item label="顾客名称">{{orderInfo.addressName}}</el-descriptions-item>
      <el-descriptions-item v-if="$store.state.visitorMode" label="联系方式">**********</el-descriptions-item>
      <el-descriptions-item v-else label="联系方式">{{orderInfo.addressMobile}}</el-descriptions-item>
      <el-descriptions-item label="收货地址">{{$store.state.visitorMode ? '***************' : orderInfo.addressTotal + '--' + orderInfo.addressNote}}</el-descriptions-item>
      <el-descriptions-item label="订单备注">{{orderInfo.note}}</el-descriptions-item>
      <el-descriptions-item label="订单编号">{{orderInfo.id}}</el-descriptions-item>
      <el-descriptions-item label="下单时间">{{orderInfo.createdTime}}</el-descriptions-item>
    </el-descriptions>
    <el-divider></el-divider>
    <el-row v-if="inTheEnd" style="text-align:left">
      <el-timeline>
        <el-timeline-item v-for="(item, index) in orderInfo.log" :key="index" :timestamp="item.createdTime">
          {{item.description}}
        </el-timeline-item>
      </el-timeline>
      <el-divider></el-divider>
    </el-row>
    <el-collapse class="order_collapse">
      <el-collapse-item>
        <template slot="title">
          <span class="shop_title">共</span>
          <span class="shop_amount">&nbsp;{{orderInfo.totalAmount}}&nbsp;</span>
          <span class="shop_title">件商品,预计收入</span>
          <span class="shop_price">￥{{orderInfo.totalPrice}}</span>
          <span class="shop_promotion" v-if="promotionTotal(orderInfo) !== ''">{{ '（已优惠' + promotionTotal(orderInfo) + '元）' }}</span>
        </template>
        <el-table class="shop_list" :data="orderInfo.itemInfo" stripe>
          <el-table-column prop="title" label="商品名" width="400">
          </el-table-column>
          <el-table-column prop="specification" label="规格" width="150">
          </el-table-column>
          <el-table-column prop="price" label="单价（元）" width="150">
          </el-table-column>
          <el-table-column prop="amount" label="数量" width="150">
          </el-table-column>
          <el-table-column prop="totalPrice" label="总计（元）" width="150">
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
  </el-row>
</template>

<script>
import GLOBAL from '@/utils/global.js';
  export default {
    props: {
      orderInfo: {
        type: Object,
        required: true,
      },
      inTheEnd: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    name: "OrderCard",
    components: {},
    computed: {
    },
    data() {
      return {
        GLOBAL,
      };
    },
    methods: {
      promotionTotal(val){
        if(!this.$store.state.visitorMode && GLOBAL.debugMode){
          console.log(val);
        }
        let total = 0;
        for(let item of val.promotionDetail){
          // 优惠金额计算
          total += item.reductionPrice;
        }
        return total === 0 ? '' : total + '';
      }
    },
  };
</script>

<style>
  .ordercard_framework {
    margin-bottom: 30px;
  }

  .order_description {
    margin-left: 20px;
    font-size: 16px;
  }

  .shop_title {
    font-size: 16px;
    color: #303133;
  }

  .shop_amount {
    font-size: 20px;
    font-weight: bold;
    color: #303133;
  }

  .shop_price {
    font-size: 20px;
    font-weight: bold;
    /*color: rgb(255, 127, 14);*/
    color: #f56c6c;
  }

  .shop_promotion {
    font-size: 20px;
    /*font-weight: bold;*/
    color: #f56c6c;
  }

  .el-collapse-item__header,
  .el-collapse-item__wrap {
    padding-left: 20px;
    padding-right: 20px;
    background-color: rgb(249, 249, 249);
  }

  .el-collapse,
  .el-collapse-item__wrap {
    border: none;
  }

  .el-table__header {
    width: 100% !important;
  }

  .el-table__body {
    width: 100% !important;
  }
</style>
